import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { userManagementBaseUrl, userManagement } from "../endpoints";

// Define a service using a base URL and expected endpoints
export const countryService = createApi({
  reducerPath: "countryService",
  baseQuery: fetchBaseQuery({ baseUrl: userManagementBaseUrl }),
  tagTypes: ["country"],
  endpoints: (builder) => ({
    getAllCountryWithPagination: builder.mutation({
      query: (body) => {
        console.log("getAllCountryWithPagination body:", body); // ✅ log the payload

        return {
          url: `${userManagement.countryController.getAllCountryWithPagination}/${body.page}/${body.offset}?orderBy=${body.orderBy}`,
          method: "GET",
          headers: { Authorization: `Bearer ${body.token}` },
        };
      },
    }),

    getAllCountry: builder.mutation({
      query: (body) => {
        return {
          url: `${userManagement.countryController.getAllCountries}`,
          method: "GET",
          headers: { Authorization: `Bearer ${body.token}` },
          body: body.payload,
        };
      },
    }),
    getAllCountryWithSearch: builder.mutation({
      query: (body) => {
        return {
          url: `${userManagement.countryController.getAllCountriesWithSearch}`,
          method: "POST",
          headers: { Authorization: `Bearer ${body.token}` },
          body: body.payload,
        };
      },
    }),

    updateCountry: builder.mutation({
      query(body) {
        return {
          url: `${userManagement.countryController.updateCountry}`,
          method: "PUT",
          headers: { Authorization: `Bearer ${body.token}` },
          body: body.payload,
        };
      },
    }),
    deleteCountry: builder.mutation({
      query(body) {
        return {
          url: `${userManagement.countryController.deleteCountry}/${body.id}`,
          method: "DELETE",
          headers: { Authorization: `Bearer ${body.token}` },
        };
      },
    }),
    getCountryById: builder.mutation({
      query(body) {
        return {
          url: `${userManagement.countryController.getCountryById}/${body.id}`,
          method: "GET",
          headers: { Authorization: `Bearer ${body.token}` },
        };
      },
    }),
    saveCountry: builder.mutation({
      query(body) {
        return {
          url: `${userManagement.countryController.saveCountry}`,
          method: "POST",
          headers: { Authorization: `Bearer ${body.token}` },
          body: body.payload,
        };
      },
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetAllCountryMutation,
  useDeleteCountryMutation,
  useGetCountryByIdMutation,
  useSaveCountryMutation,
  useUpdateCountryMutation,
  useGetAllCountryWithSearchMutation,
  useGetAllCountryWithPaginationMutation
} = countryService;
